import { Money } from 'types';
import PayableAtPropertyLineItem from './PayableAtPropertyLineItem';

interface PayableAtPropertyLineItemProps {
  formattedCheckIn: string;
  payableAtPropertyBreakdown?: Array<{
    description: string;
    charge: Money;
  }>;
}

const PayableAtPropertyLineItems = ({ formattedCheckIn, payableAtPropertyBreakdown }: PayableAtPropertyLineItemProps) =>
  payableAtPropertyBreakdown ? (
    <>
      {payableAtPropertyBreakdown.map(({ description, charge }) => (
        <PayableAtPropertyLineItem
          key={`payable-at-property-${description}`}
          formattedCheckIn={formattedCheckIn}
          description={description}
          charge={charge}
        />
      ))}
    </>
  ) : null;

export default PayableAtPropertyLineItems;
